<template>
  <BreadCrumb PageTitle="Liste des colis" />
  <ImportColis />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ImportColis from "../../components/Colis/ImportColis.vue";

export default defineComponent({
  name: "ImportColisPage",
  components: {
    BreadCrumb,
    ImportColis,
  },
});
</script>